import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Subject } from 'rxjs';
import * as firebase from 'firebase/compat/app';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  //class properties
  user: firebase.default.User;
  //user: firebase.User;
  token: string = '';
  loginStatusChange: Subject<firebase.default.User> = new Subject<firebase.default.User>();
  //loginStatusChange: Subject<firebase.User> = new Subject<firebase.User>();

  //inject services
  constructor(public auth: AngularFireAuth) { 
    //listen for changes from Firebase
    this.auth.authState.subscribe(user => {
      //capture the change
      this.user = user;

      //get the user's token
      if (this.user != null) {
        this.user.getIdToken(false).then((token) => {
          this.token = token;
        });
      }
      
      //update listener for this change
      this.loginStatusChange.next(this.user);
    });
  }

  //get logged in user info
  getLoggedInUser() {
    return this.user;
  }

  //get the user's token
  getToken() {
    return this.token;
  }

  //determines if the user is logged in
  isLoggedIn(): boolean {
    if (this.user == null || this.user == undefined) {
      return false;
    } else {
      return true;
    }
  }

  //logs the user in using Microsoft provider
  async login() {
    //register the Microsoft provider
    //var provider = new firebase.auth.OAuthProvider('microsoft.com');
    var provider = new firebase.default.auth.OAuthProvider('microsoft.com');

    //limit to just the specified tenant
    provider.setCustomParameters({
      tenant: '20d185f7-9b28-444a-bb60-7cb968d8c1bd'
    });

    //prompt login
    await this.auth.signInWithPopup(provider).then( () => {
      //nothing for now
    }).catch(error => {
      console.log(error);
    });
  }

  //logs the user out using the Microsoft provider
  logout() {
    this.auth.signOut();
  }
  
}
